import React, { Fragment } from 'react';
import classnames from 'classnames';
import * as PropTypes from 'prop-types';

import { isBrowser } from '../../utils';
import SmoothScrollAnchor from '../SmoothScrollAnchor';
import MiniBlurredGate from '../../widgets/gatedSignupPopup/partialGate/MiniBlurredGate';

import classes from './index.module.css';
import classNames from 'classnames';

const PieChartLegend = (props) => {
  const { chartData, samePageLinks, legendHeader, legendFooter, legendLinksAsButton, blurLegends, blurLegendCriteria } = props;

  const getLegendItemView = (item) => {
    const { color, name, percent, link } = item;
    const backgroundColor = color || '#fff';

    return (
      <li
        className={classnames(
          classes.legendItem,
          'pie-chart-legend-item d-flex align-items-center my-0 py-0'
        )}
      >
        <div
          className={classnames(classes.legendCircle, 'pie-chart-legend-circle')}
          style={{ backgroundColor }}
        />
        <span
          className={classnames(classes.separator, 'pie-chart-legend-separator d-inline-block')}
        />
        {link ? (
          <>
            {samePageLinks ? (
              <SmoothScrollAnchor
                className={classnames(classes.link, 'list-link semi-bold-font')}
                href={link}
                title={name}
              >
                {item.name}
              </SmoothScrollAnchor>
            ) : legendLinksAsButton ? (
              <span
                role="link"
                className={classnames(classes.link, 'list-link z-link semi-bold-font')}
                onClick={() => isBrowser() && (window.location.href = link)}
              >
                {name}
              </span>
            ) : (
              <a className={classnames(classes.link, 'list-link semi-bold-font')} href={link}>
                {name}
              </a>
            )}
            <span className="openSansBlackBold">{`, ${percent}%`}</span>
          </>
        ) : (
          <>
            <span>{name}</span>
            <span className="openSansBlackBold">{`, ${percent}%`}</span>
          </>
        )}
      </li>
    );
  };

  return (
    <ul className="pie-chart-legend-container z-m-0 z-p-0">
      {legendHeader && legendHeader}
      {chartData.map((item, index) => {
        const showBlur = blurLegends && blurLegendCriteria(index);
        return (
          <Fragment key={item.name + index}>
            {showBlur && index === 3 && <MiniBlurredGate />}
            <div className={classNames({ [classes.blurLegend]: showBlur }, 'mt-2')}>
              {getLegendItemView(item)}
            </div>
          </Fragment>
      )})}
      {legendFooter && legendFooter}
    </ul>
  );
};

const propTypes = {
  chartData: PropTypes.arrayOf(PropTypes.any),
  samePageLinks: PropTypes.bool,
  legendHeader: PropTypes.any,
  legendFooter: PropTypes.any,
  legendLinksAsButton: PropTypes.bool,
  blurLegends: PropTypes.bool,
  blurLegendCriteria: PropTypes.func
};

const defaultProps = {
  chartData: [],
  samePageLinks: false,
  legendHeader: '',
  legendFooter: '',
  legendLinksAsButton: false,
  blurLegends: false,
  blurLegendCriteria: () => false
};

PieChartLegend.propTypes = propTypes;
PieChartLegend.defaultProps = defaultProps;

export default PieChartLegend;
